import React, { useState } from 'react';
import { useWorkspace } from '../contexts/WorkspaceContext';
import { useNotification } from '../contexts/NotificationContext';
import { LockClosedIcon } from '@heroicons/react/24/solid';
import UpgradeModal from './UpgradeModal';

const LockedWorkspaceBanner: React.FC = () => {
    const { isCurrentWorkspaceLocked } = useWorkspace();
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);

    if (!isCurrentWorkspaceLocked) return null;

    return (
        <div className="sticky top-0 z-[40] bg-white/40 dark:bg-slate-900/40 backdrop-blur-md border-b border-indigo-500/20 dark:border-indigo-400/10 py-2.5 px-6 shadow-[0_4px_20px_-2px_rgba(0,0,0,0.1)] transition-all animate-in fade-in slide-in-from-top-4 duration-500">
            <div className="max-w-7xl mx-auto flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center gap-4">
                    <div className="flex-shrink-0 w-9 h-9 rounded-2xl bg-gradient-to-br from-indigo-500 to-sky-500 flex items-center justify-center shadow-lg shadow-indigo-500/20">
                        <LockClosedIcon className="w-5 h-5 text-white" />
                    </div>
                    <div className="space-y-0.5">
                        <h3 className="text-sm font-bold text-indigo-900 dark:text-indigo-100 flex items-center gap-2">
                            Restricted Workspace
                            <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-indigo-100 dark:bg-indigo-500/20 text-indigo-600 dark:text-indigo-300 uppercase tracking-wider">Free Plan</span>
                        </h3>
                        <p className="text-xs text-indigo-800/70 dark:text-indigo-300/60 font-medium">
                            Only analytics and dashboard are accessible in this workspace. Upgrade to unlock full potential.
                            <span className="ml-1 text-indigo-600/80 dark:text-indigo-400/80">Your data is safe with us and we are never going to delete from our end.</span>
                        </p>
                    </div>
                </div>
                <div className="flex items-center gap-3">
                    <button
                        onClick={() => setShowUpgradeModal(true)}
                        className="px-5 py-2 text-xs font-bold text-white bg-indigo-600 hover:bg-indigo-700 active:scale-95 rounded-xl shadow-lg shadow-indigo-600/20 transition-all duration-200"
                    >
                        Upgrade to Pro
                    </button>
                </div>
            </div>

            {/* Upgrade Modal */}
            <UpgradeModal
                isOpen={showUpgradeModal}
                onClose={() => setShowUpgradeModal(false)}
            />
        </div>
    );
};

export default LockedWorkspaceBanner;
